import React, { useState } from "react";
import Stepper from "../components/partials/steps";
import Logo from "../assets/icons/logo.svg";
import Input, { TextArea } from "../components/partials/inputs";
import PrimaryBtn from "../components/partials/btn";
import Done from "../assets/icons/_Step icon base_done.svg";
import Pending from "../assets/icons/_Step icon base.svg";
import Stationery from "../assets/icons/_Step icon base_stationary.svg";
import Plus from "../assets/icons/plus.svg";
import MultiSelectDropdown from "../components/partials/select";
import SuccessModal from "../components/modals/successmodal";

const Flow = () => {
  const [activeStep, setActiveStep] = useState(1);
  const [successmodal, setSuccessmodal] = useState(false);
  const [system, setSystem] = useState(null),
    [child, setChild] = useState(false);
  const steps = [
    {
      id: 1,
      title: "List Data Systems",
      description: "Choose a secure password",
    },
    {
      id: 2,
      title: "Data Collection",
      description: "Choose a secure password",
    },
    {
      id: 3,
      title: "Data Flow and Visualisation",
      description: "Start collaborating with your team",
    },
    {
      id: 4,
      title: "External Data Sharing",
      description: "Choose a secure password",
    },
    {
      id: 5,
      title: "Fit-for-purpose",
      description: "Start collaborating with your team",
    },
  ];
  const handleSubmit = () => {
    if (system) {
      setChild(true);
    } else {
      alert("Please fill in the required fields");
    }
  };
  return (
    <div>
      <div className="min-h-screen relative w-full flex">
        <div className="w-[30%] min-h-full bg-[#2070B8] p-8">
          <img src={Logo} alt="" className="" />
          <div className="mt-12 flex gap-6">
            <div className="flex flex-col items-center">
              {steps.map((step, index) => (
                <div key={step.id} className="flex items-center">
                  <div className="w-8">
                    <img
                      src={
                        activeStep > step?.id
                          ? Done
                          : activeStep === step?.id
                          ? Pending
                          : Stationery
                      }
                      alt=""
                      className=""
                    />

                    {index < steps.length - 1 && (
                      <div className="h-10 w-0.5 my-2 mx-auto bg-gray-300"></div>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="space-y-10">
              {steps.map((step) => (
                <div
                  key={step.id}
                  className={`cursor-pointer`}
                  onClick={() => setActiveStep(step.id)}
                >
                  <h2 className="text-base font-medium text-white">
                    {step.title}
                  </h2>
                  <p className="text-base font-normal text-white">
                    {step.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="w-[70%] relative min-h-screen flex justify-center py-20 items-center">
          {activeStep === 1 && !child && (
            <div>
              <h2 className="text-3xl font-semibold text-sec">Data Systems</h2>
              <p className="mt-1 text-sm text-es-gray-100 font-normal">
                Complete details correctly.
              </p>
              <form
                action=""
                onClick={(e) => e?.preventDefault()}
                className="mt-6"
              >
                <h5 className="my-2 text-base font-semibold text-sec">
                  Data Systems
                </h5>
                <div className="space-y-4 w-96">
                  <Input
                    onChange={(e) => setSystem(e.target.value)}
                    label="List all the data systems / tools in use by the department **"
                    placeholder="ERP Module"
                  />
                </div>
                <div
                  //   onClick={() => setInputs([...inputs, ...inputs])}
                  className="mt-4 cursor-pointer flex gap-1 items-center"
                >
                  <img src={Plus} alt="" className="" />
                  <small className="text-sm text-primary font-normal">
                    Add another
                  </small>
                </div>
                <div className="mt-6 w-96">
                  <PrimaryBtn
                    text="Continue"
                    width="w-full"
                    onClick={handleSubmit}
                  />
                </div>
              </form>
            </div>
          )}
          {activeStep === 1 && child && (
            <div className="">
              <h2 className="text-3xl font-semibold text-sec">Data Systems</h2>
              <p className="mt-1 text-sm text-es-gray-100 font-normal">
                Complete details correctly.
              </p>
              <button className="h-11 w-44 mt-6 rounded-lg bg-[#E8EEF3] main-shadow main-border capitalize text-base font-medium text-[#3F516C]">
                {system}
              </button>
              <form
                action=""
                onClick={(e) => e?.preventDefault()}
                className="mt-6"
              >
                <h5 className="my-2 text-base font-semibold text-sec">
                  Data Systems
                </h5>
                <div className="space-y-4 w-96">
                  <Input
                    readonly={true}
                    label="Data system in use by the department *"
                    placeholder="ERP Module"
                  />
                  <Input
                    label="Name of the system developer *"
                    placeholder="E.g. SPA, In-house etc"
                  />
                  <Input
                    label="Date of first installation *"
                    placeholder=" Enter Date Installed"
                  />
                  <Input
                    label="Amount paid for annual license fees or maintenance *"
                    placeholder="Enter Annual License Fees"
                  />
                  <Input
                    label="Describe the main purpose of the system *"
                    placeholder="e.g. Billing, NRW management, Payroll"
                  />
                </div>
                <div className="mt-6 w-96">
                  <PrimaryBtn
                    text="Continue"
                    width="w-full"
                    onClick={() => setActiveStep(2)}
                  />
                </div>
              </form>
            </div>
          )}
          {activeStep === 2 && (
            <div>
              <h2 className="text-3xl font-semibold text-sec">
                Data Collection
              </h2>
              <p className="mt-1 text-sm text-es-gray-100 font-normal">
                Complete form correctly.
              </p>
              <button className="h-11 w-44 mt-6 rounded-lg bg-[#E8EEF3] main-shadow main-border capitalize text-base font-medium text-[#3F516C]">
                {system}
              </button>
              <form
                action=""
                onClick={(e) => e?.preventDefault()}
                className="mt-6"
              >
                <h5 className="my-2 text-base font-semibold text-sec">
                  Data Collection Tool
                </h5>
                <div className="space-y-4 w-96">
                  <Input
                    readonly={true}
                    label="Name of the tool used to collect data *"
                    placeholder="E.g. mobile meter reading app"
                  />

                  <MultiSelectDropdown
                    label="What technology is used to collect the information *"
                    options={[
                      {
                        label: "Option 1",
                        value: "option1",
                      },
                    ]}
                  />
                  <MultiSelectDropdown
                    label="How often is data collected *"
                    options={[
                      {
                        label: "Option 1",
                        value: "option1",
                      },
                    ]}
                  />
                  <MultiSelectDropdown
                    label="How well does the data collection tool serve its purpose?  "
                    options={[
                      {
                        label: "Option 1",
                        value: "option1",
                      },
                    ]}
                  />
                </div>
                <div className="mt-6  gap-2 items-center w-96 grid grid-cols-2">
                  <button
                    onClick={() => setActiveStep(activeStep - 1)}
                    className="main-shadow main-border h-11 bg-transparent text-es-gray-200 text-base font-medium
                "
                  >
                    Go Back
                  </button>
                  <PrimaryBtn
                    text="Continue"
                    width="w-full"
                    onClick={() => setActiveStep(3)}
                  />
                </div>
              </form>
            </div>
          )}
          {activeStep === 3 && (
            <div>
              <h2 className="text-3xl font-semibold text-sec">
                Data Flow and <br /> Visualisation
              </h2>
              <p className="mt-1 text-sm text-es-gray-100 font-normal">
                Complete form correctly.
              </p>
              <button className="h-11 w-44 mt-6 rounded-lg bg-[#E8EEF3] main-shadow main-border capitalize text-base font-medium text-[#3F516C]">
                {system}
              </button>
              <form
                action=""
                onClick={(e) => e?.preventDefault()}
                className="mt-6"
              >
                <h5 className="my-2 text-base font-semibold text-sec">
                  Data Collection Tool
                </h5>
                <div className="space-y-4 w-96">
                  <MultiSelectDropdown
                    label="Which depts and system feeds data to this system *"
                    options={[
                      {
                        label: "Option 1",
                        value: "option1",
                      },
                    ]}
                  />
                  <Input
                    label="Which system receive data from this system?"
                    placeholder="E.g. Commercial-billing system-customers "
                  />
                  <Input
                    label="Which dept receive data from this system?"
                    placeholder="E.g. Finances"
                  />
                  <TextArea
                    label="What Reports are produced for decision-making?"
                    placeholder="E.g. Commercial-billing system-customers numbers"
                  />
                </div>
                <div className="mt-6  gap-2 items-center w-96 grid grid-cols-2">
                  <button
                    onClick={() => setActiveStep(activeStep - 1)}
                    className="main-shadow main-border h-11 bg-transparent text-es-gray-200 text-base font-medium
                "
                  >
                    Go Back
                  </button>
                  <PrimaryBtn
                    text="Continue"
                    width="w-full"
                    onClick={() => setActiveStep(4)}
                  />
                </div>
              </form>
            </div>
          )}
          {activeStep === 4 && (
            <div>
              <h2 className="text-3xl font-semibold text-sec">
                External Data Sharing
              </h2>
              <p className="mt-1 text-sm text-es-gray-100 font-normal">
                Complete form correctly.
              </p>
              <button className="h-11 w-44 mt-6 rounded-lg bg-[#E8EEF3] main-shadow main-border capitalize text-base font-medium text-[#3F516C]">
                {system}
              </button>
              <form
                action=""
                onClick={(e) => e?.preventDefault()}
                className="mt-6"
              >
                <div className="space-y-4 w-96">
                  <MultiSelectDropdown
                    label="Which KPI does this system inform? *"
                    options={[
                      {
                        label: "Option 1",
                        value: "option1",
                      },
                    ]}
                  />
                  <MultiSelectDropdown
                    label="Which Area does this system inform? *"
                    options={[
                      {
                        label: "Option 1",
                        value: "option1",
                      },
                    ]}
                  />
                  <TextArea
                    label="Which dept and system receive data from this system?"
                    placeholder="Which dept and system receive data from this system?"
                  />
                  <MultiSelectDropdown
                    label="How effective is the communication between this system and the one that feeds it information? *"
                    options={[
                      {
                        label: "Option 1",
                        value: "option1",
                      },
                    ]}
                  />
                </div>
                <div className="mt-6  gap-2 items-center w-96 grid grid-cols-2">
                  <button
                    onClick={() => setActiveStep(activeStep - 1)}
                    className="main-shadow main-border h-11 bg-transparent text-es-gray-200 text-base font-medium
                "
                  >
                    Go Back
                  </button>
                  <PrimaryBtn
                    text="Continue"
                    width="w-full"
                    onClick={() => setActiveStep(5)}
                  />
                </div>
              </form>
            </div>
          )}
          {activeStep === 5 && (
            <div>
              <h2 className="text-3xl font-semibold text-sec">
                Fit-for-purpose
              </h2>
              <p className="mt-1 text-sm text-es-gray-100 font-normal">
                Complete form correctly.
              </p>
              <button className="h-11 w-44 mt-6 rounded-lg bg-[#E8EEF3] main-shadow main-border capitalize text-base font-medium text-[#3F516C]">
                {system}
              </button>
              <form
                action=""
                onClick={(e) => e?.preventDefault()}
                className="mt-6"
              >
                <div className="space-y-4 w-96">
                  <MultiSelectDropdown
                    label="Level of effectiveness for purpose *"
                    options={[
                      {
                        label: "Option 1",
                        value: "option1",
                      },
                    ]}
                  />
                  <MultiSelectDropdown
                    label="Data Security *"
                    options={[
                      {
                        label: "Option 1",
                        value: "option1",
                      },
                    ]}
                  />
                  <Input
                    label="Support and Training Needs"
                    placeholder="Enter"
                  />
                  <Input label="Improvements required" placeholder="Enter" />
                </div>
                <div className="mt-6  gap-2 items-center w-96 grid grid-cols-2">
                  <button
                    onClick={() => setActiveStep(activeStep - 1)}
                    className="main-shadow main-border h-11 bg-transparent text-es-gray-200 text-base font-medium
                "
                  >
                    Go Back
                  </button>
                  <PrimaryBtn
                    text="Continue"
                    width="w-full"
                    onClick={() => setSuccessmodal(true)}
                  />
                </div>
              </form>
            </div>
          )}
          <div className="absolute bottom-7 left-1/2 transform -translate-x-1/2 w-full">
            <div className="w-full flex justify-center items-center">
              <Stepper
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                totalSteps={steps?.length}
              />
            </div>
          </div>
        </div>
      </div>
      {successmodal && <SuccessModal page="/dashboard" />}
    </div>
  );
};

export default Flow;
